<template>
  <div id="vehicle">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>运输溯源&nbsp;/&nbsp;车辆管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <el-input class="elinputs" v-model="beginData.gpsImei" placeholder="GPS设备条码"></el-input>
           <!-- <el-input class="elinputs" v-model="beginData.id" placeholder="搜索编号"></el-input> -->
           <el-input class="elinputs" v-model="beginData.number" placeholder="车牌号"></el-input>
            <el-select v-model="beginData.type" placeholder="车型选择" class="elinputs">
                <el-option v-for="item in beginData.types" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='reset'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="number" label="车牌号" sortable  width="100"></el-table-column>
        <el-table-column label="车型" width="110">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.type==1">小型</p>
                <p class="boldfont" v-if="scope.row.type==2">中型</p>
                <p class="boldfont" v-if="scope.row.type==3">大型</p>
            </template>
        </el-table-column>
        <el-table-column prop="areasName" label="所属地区" min-width="160"></el-table-column>
        <el-table-column prop="load" label="载重（吨）" sortable width="140"></el-table-column>
        <el-table-column prop="gpsImei" label="GPS设备条码" sortable width="160"></el-table-column>
        <el-table-column prop="gpsKey" label="GPS用户唯一密钥" width="300"></el-table-column>
        <el-table-column label="运输记录" width="160">
            <template slot-scope="scope">
                <p class="boldfont" style="color:#11A983;text-decoration:underline;cursor: pointer;" @click="carriageDet(scope.row)">查看</p>
            </template>
        </el-table-column>
        <el-table-column label="是否显示" width="160">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isDisplay">是</p>
                <p class="boldfont" v-else style="color:#F56C6C">否</p>
            </template>
        </el-table-column>
        <el-table-column prop="addTime" label="添加时间" width="180"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>

        <el-table-column label="操作" fixed="right" min-width="200">
            <template slot-scope="scope">
            <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'vehicle:update')"><i class="el-icon-edit"></i> 编辑</el-button>
            <el-button size="mini" type="danger" @click="stop(scope.row,'vehicle:delete')"><i class="el-icon-delete"></i> 删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog :title="mydata.name" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 所属地区">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 车牌号：">
               <el-input placeholder="请输入车牌号" v-model="mydata.number" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 车 型：">
                <el-select v-model="mydata.type" placeholder="车型选择">
                    <el-option
                    v-for="item in beginData.types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 载重（吨）：">
               <el-input placeholder="数量" v-model="mydata.load" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* GPS设备条码：">
               <el-input placeholder="数量" v-model="mydata.gpsImei" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* GPS用户唯一密钥：">
               <el-input placeholder="数量" v-model="mydata.gpsKey" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="mydata.isDisplay" label=true>是</el-radio>
                <el-radio v-model="mydata.isDisplay" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
        <el-dialog title="运输记录" :visible.sync="dialogFormVisible1" width="60%" @close="dataClose">
            <el-form>
                <el-table :data="tableData2" @selection-change="handleSelectionChange" border stripe style="width: 100%">
                <el-table-column prop="id" label="序号" width="80"></el-table-column>
                <el-table-column prop="truckNumber" label="车牌号" width="120"></el-table-column>
                <el-table-column prop="licenseName" label="司机" width="120"></el-table-column>
                <el-table-column prop="addTime" label="出发时间" width="160"></el-table-column>
                <el-table-column prop="departurePlace" label="出发地" width="260"></el-table-column>
                <el-table-column label="车辆轨迹" sortable width="160">
                    <template slot-scope="scope">
                        <p class="boldfont" style="color:#11A983;text-decoration:underline;cursor: pointer;" @click="lookCarOne(scope.row.id)">查看</p>
                    </template>
                </el-table-column>
                <el-table-column prop="finishTime" label="完成时间" width="160"></el-table-column>
                <el-table-column prop="addTime" label="添加时间" width="160"></el-table-column>
                <el-table-column prop="updateTime" label="修改时间" width="160"></el-table-column>
                <el-table-column label="状态" sortable width="160">
                    <template slot-scope="scope">
                        <p class="boldfont" v-if="scope.row.status==1">待出发</p>
                        <p class="boldfont" v-if="scope.row.status==2">在途中</p>
                        <p class="boldfont" v-if="scope.row.status==3">已完成</p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paging">
                <span>
                共
                <i class="pagingNum">{{carriage.total}}</i> 条
                </span>
                <Paging :gopage="carriage.total" @pag="pags"></Paging>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog title="车辆轨迹" :visible.sync="dialogFormVisible2" width="60%" @close="closeCar">
        <baidu-map class="map" :center="markerPoint" :zoom="zoom" :scroll-wheel-zoom="true" @zoomend="syncCenterAndZoom">
            <bm-marker :position="transportData.initial" :icon="{url:imgentrepot, size: {width: 48, height: 44}}">

            </bm-marker>
            <bm-polyline :path="polylinePath" stroke-color="red" :stroke-opacity="0.5" :stroke-weight="8" @lineupdate="updatePolylinePath"></bm-polyline>
            <bm-marker :position="markerPoint" :icon="{url: imgcar, size:{width:48,height: 36}}" @click="infoWindowOpen">
                <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
                    <p>车&emsp;次：{{transportData.sn}}</p>
                    <p>车牌号：{{transportData.truckNumber}}</p>
                    <p>时&emsp;速：{{transportData.speed}} km/h</p>
                    <p>司&emsp;机：{{transportData.licenseName}}</p>
                </bm-info-window>
            </bm-marker>
        </baidu-map>
        <!-- <p @click='haha'>ceshi</p> -->
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "vehicle",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{types:[{name:'小型',id:'1'},{name:'中型',id:'2'},{name:'大型',id:'3'}]},
        tableData: [],
        tableData2:[],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        dialogFormVisible1: false,
        dialogFormVisible2: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname:JSON.stringify({name:'车辆管理',hint:'vehicle:export'}),
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isDisplay:'true'},
        multipleSelection:[],
        carriage:{total:0,pageNum: 1,pageSize: 10,truckId:''},
        imgcar: require("../../assets/img/car.png"),
        imgentrepot:require("../../assets/img/entrepot.png"),
        polylinePath: [],
        markerPoint:{lng: 116.401856, lat: 39.913927},
        zoom: 12.8,
        transportData:{},
        show:true,
    };
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
    closeCar(){
        clearInterval(this.timer);
    },
    infoWindowClose () {
        this.show = false
    },
    infoWindowOpen () {
        this.show = true
    },
    updatePolylinePath (e) {
      this.polylinePath = e.target.getPath()
    },
    syncCenterAndZoom(e){
      this.zoom = e.target.getZoom()
    },
    lookCarOne(id){
        const _this = this
        this.fullscreenLoading = true
        _this.timer = setInterval(function() {
            _this.lookCar(id)
        },5000)
        _this.lookCar(id)
    },
    //车辆轨迹
    lookCar(id){
        this.$axios.post(`/api-s/getGpsInfoList/${id}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            this.fullscreenLoading = false
            if(res.data.success){
                if(res.data.gpsInfoList.length==0){
                    this.$message('暂无车辆轨迹信息')
                    return
                }
                let log = []
                let dataArr = res.data.gpsInfoList
                dataArr.forEach(x=>{
                    log.push({lng:x.lon,lat:x.lat})
                })
                this.polylinePath = log
                this.markerPoint = {lng:log[log.length-1].lng, lat:log[log.length-1].lat}
                this.dialogFormVisible2 = true
                res.data.transportRecordInfo.initial = {lng:log[0].lng, lat:log[0].lat}
                // res.data.transportRecordInfo.speed = dataArr[dataArr.length-1].spe
                // // 信息处理
                this.transportData = res.data.transportRecordInfo
            }else{
                this.$message(res.data.msg)
            }
        })
    },
    reset(){
        this.$router.push('/refresh')
    },
    // 获取省市传入的id
    gainSS(i){
        this.userdata.areasId = i.id
    },
    //   查看运输记录
    carriageDet(row){
        this.carriage.truckId=row.id
        let data = this.$qs.stringify({
            pageNum: this.carriage.pageNum,
            pageSize: this.carriage.pageSize,
            truckId:row.id,
            adminAreasId: this.userdata.areasId
        });
        this.$axios.post(`/api-s/getTransportRecordList`,data,{ headers: { accessToken: this.userdata.token }})
        .then(res=>{
            if(res.data.success==true){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.$set(this, "tableData2", res.data.pageInfo.list);
                this.carriage.total = res.data.pageInfo.total
                this.dialogFormVisible1 = true
            }else{
                alert(res.data.msg)
            }
        })
    },
    pags(val){
        this.carriage.pageNum = val.pageNum
        this.carriage.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.carriageDet(this.carriage.truckId)
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('vehicle:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('vehicle:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('vehicle:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteTruck/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isDisplay:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isDisplay:'true'}
        }
        this.begin()
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(this.mydata.areasId == undefined || this.mydata.areasId == ''){
            return this.$message('请选择所属地区')
        }
        if(!this.mydata.number||!this.mydata.type||!this.mydata.load||!this.mydata.gpsImei||!this.mydata.gpsKey){
            this.$message('请完善必填信息')
            return
        }
        // 判断是点击哪个
        let url = ``
        this.fullscreenLoading = true;
        if(this.mydata.stat==0){
            url = `/api-s/addTruck`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateTruck`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
            }
        });
    },

    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    handleSizeChange1(val) {
      this.carriage.pageSize = val;
      this.fullscreenLoading = true;
    },
    handleCurrentChange1(val) {
      this.carriage.pageNum = val;
      this.fullscreenLoading = true;
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        gps:this.beginData.gps,
        number:this.beginData.number,
        type:this.beginData.type,
        discount:this.beginData.discount,
        adminAreasId: this.userdata.areasId
      });
        this.$axios.post(`/api-s/getTruckList`, data, {headers: { accessToken: this.userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
                this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.name = '添加车辆'
            this.mydata.stat = i
        }else if(i == 1){
            row.name = '编辑车辆'
            row.stat = i
            row.isDisplay += ''
            row.type += ''
            this.sheng = Number(row.areasId.split(',')[0])
            this.shi = Number(row.areasId.split(',')[1])
            this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteTruck/${row.id}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#vehicle .map {
  width: 100%;
  height: 500px;
}
#vehicle .el-input__inner {
  margin: 10px 0;
}
#vehicle .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#vehicle .el-menu-item.is-active{
  background: none
}
#vehicle .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#vehicle .el-tag{
  margin-right: 12px;
}
#vehicle .el-select {
  /* margin: 0 8px; */
  width: 100%
}
#vehicle .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#vehicle .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#vehicle .el-form-item__content {
    display: flex;
    width: 100%;
}
#vehicle .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#vehicle .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#vehicle .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#vehicle .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#vehicle .el-dialog__body {
  height: 100%;
}
#vehicle .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#vehicle .el-form-item__label{
    width: 190px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
